import { render, staticRenderFns } from "./ShenPiToDoList.vue?vue&type=template&id=375fbbd5"
import script from "./ShenPiToDoList.vue?vue&type=script&lang=js"
export * from "./ShenPiToDoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports